import React from 'react'
import { View, StyleSheet, TouchableWithoutFeedback } from 'react-native'
import { format, parseISO } from 'date-fns'

import Text from '../Text'
import colors from '../../config/colors'

function BoomButton({ boom, id, onPress }) {
  console.log(boom)
  let date = format(parseISO(boom.updated), 'do MMMM yyyy')

  return (
    <TouchableWithoutFeedback onPress={onPress}>
      <View style={styles.card}>
        <View style={styles.detailsContainer}>
          <Text style={styles.title} numberOfLines={1}>
            {boom.user.name}
          </Text>
          <Text style={styles.info} numberOfLines={1}>
            <b>Last Updated:</b> {date}
          </Text>
        </View>
      </View>
    </TouchableWithoutFeedback>
  )
}

const styles = StyleSheet.create({
  card: {
    borderRadius: 10,
    backgroundColor: colors.light,
    marginBottom: 20,
    // overflow: "hidden",
  },
  detailsContainer: {
    padding: 20,
  },
  subTitle: {},
  info: {
    fontSize: 16,
    marginBottom: 5,
  },
  date: {
    // marginBottom: 7,
    fontWeight: 'normal',
    fontSize: 14,
    marginBottom: 12,
    // flex: 1,
  },
  title: {
    // marginBottom: 7,
    color: colors.secondary,
    fontWeight: 'bold',
    fontSize: 20,
    marginBottom: 3,
    // flex: 1,
  },
})

export default BoomButton
